<template>
  <Table :columns="columns" :data="processedClaims" :is-row-clickable="true" @row-click="redirectToClaimDetailsPage">
    <template #friendlyId="{ row }">
      <div class="flex flex-col">
        <div class="flex items-center">
          <p>{{ row.friendlyId }}</p>
        </div>
        <div class="mt-2">
          <span
            :class="[
              getClaimStatusBannerStyle(row.status.color),
              'inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium',
            ]"
          >
            {{ row.status.text }}
          </span>
        </div>
        <div
          v-if="row.requiredAction"
          class="mt-2 inline-flex items-center px-2 py-1 rounded-md bg-yellow-100 border border-yellow-300 text-yellow-800 text-xs font-medium"
        >
          <ExclamationCircleIcon class="w-4 h-4 mr-1" />
          Une action est requise de votre part
        </div>
      </div>
    </template>
    <template #filedDate="{ row }">
      <p>{{ getFormattedDate(row.filedDate) }}</p>
    </template>
    <template #customer="{ row }">
      <div class="text-gray-800 space-y-1">
        <div class="font-semibold text-sm">{{ row.customerFirstName }} {{ row.customerLastName }}</div>
        <div class="text-xs text-gray-600">
          {{ row.customerEmail }}
        </div>
      </div>
    </template>
  </Table>
</template>

<script>
import { Table } from "@estaly/ui";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  components: { Table, ExclamationCircleIcon },
  props: {
    claims: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },

  computed: {
    columns() {
      return [
        { label: this.$t("Claim Id"), field: "friendlyId", slot: "friendlyId" },
        { label: "Magasin", field: "salesChannel" },
        { label: "Produit", field: "productTitle" },
        { label: "Déclaration", field: "filedDate", slot: "filedDate" },
        { label: "Client", field: "customerEmail", slot: "customer" },
      ];
    },
    processedClaims() {
      return this.claims.map((claim) => ({
        ...claim,
        rowClass: claim.requiredAction ? "bg-yellow-50" : "",
      }));
    },
  },

  methods: {
    getClaimStatusBannerStyle(color) {
      return `bg-${color}-100 text-${color}-800`;
    },

    redirectToClaimDetailsPage(claim) {
      this.$emit("redirectToClaimDetailsPage", claim.friendlyId);
    },

    getFormattedDate(dateToFormat) {
      const currentLocale = this.$i18n.locale;
      return dateToFormat !== null ? new Date(dateToFormat).toLocaleDateString(currentLocale) : null;
    },
  },
};
</script>
